import { render, staticRenderFns } from "./ai-landing-page.html?vue&type=template&id=2c53a03c&scoped=true&external"
import script from "./ai-landing-page.js?vue&type=script&lang=js&external"
export * from "./ai-landing-page.js?vue&type=script&lang=js&external"
import style0 from "./ai-landing-page.scss?vue&type=style&index=0&id=2c53a03c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53a03c",
  null
  
)

export default component.exports